import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {  Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import Swal from "sweetalert2"


const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


function AssetTable() {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch all assets
const fetchAssets = async () => {
  setLoading(true);
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const url = `${process.env.REACT_APP_API_BASE_URL}/assets/assetdetails`;
    const res = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
      },
    });

    console.log("Response status:", res.status); 

    const data = await res.json();
    console.log("Response JSON:", data);        

    if (data.success) setAssets(data.assets);
  } catch (err) {
    console.error("Error fetching assets:", err);
  } finally {
    setLoading(false);
  }
};

  // Delete asset

const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This action will permanently delete the asset.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "rgb(207, 132, 47)",
    cancelButtonColor: "#a1a4a7",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel"
  });

  if (!result.isConfirmed) return;

  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/assets/assetdetails/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
      },
    });

    const data = await res.json();
    if (data.success) {
      setAssets((prev) => prev.filter((asset) => asset.asset_id !== id));
      Swal.fire("Deleted!", "The asset has been removed.", "success");
    } else {
      Swal.fire("Error", data.error || "Delete failed", "error");
    }
  } catch (err) {
    console.error("Error deleting asset:", err);
    Swal.fire("Error", "Something went wrong while deleting.", "error");
  }
};



  // Navigate to edit page
  const handleEdit = (id) => {
    navigate(`/assets/${id}/edit`);
  };

  useEffect(() => {
    fetchAssets();
  }, []);

  return (
    
        <Card style={cardShell}>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Asset Inventory</h5>
            <div>
              <Button
                color="primary"
                className="me-2 btn btn-outline-primary"
                onClick={() => navigate("/assets/new")}
              >
                Add Asset
              </Button>
              <Button
                color="secondary"
                className="btn btn-outline-warning"
                onClick={fetchAssets}
                disabled={loading}
              >
                {loading ? "Refreshing..." : "Refresh"}
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>Asset ID</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Description</th>
                  <th>Department</th>
                  <th>Segments</th>
                  <th>Specification</th>
                  <th>Criticality</th>
                  <th>Internal/External</th>
                  <th>Value</th>
                  <th>Create Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {assets.length === 0 ? (
                  <tr>
                    <td colSpan="12" className="text-center py-5">
                      No assets found
                    </td>
                  </tr>
                ) : (
                  assets.map((asset) => (
                    <tr key={asset.asset_id}>
                      <td>{asset.asset_id}</td>
                      <td>{asset.name}</td>
                      <td>{asset.category}</td>
                      <td>{asset.description}</td>
                      <td>{asset.department}</td>
                      <td>{asset.segments}</td>
                      <td>{asset.specification}</td>
                      <td>{asset.criticality}</td>
                      <td>{asset.internal_external}</td>
                      <td>{asset.value}</td>
                      <td>{new Date(asset.create_date).toLocaleString()}</td>
                      <td>
                        <Button
                          size="sm"
                          color="warning"
                          className="me-3 btn btn-outline-warning mb-2"
                          onClick={() => handleEdit(asset.asset_id)}
                        >
                           <i className="ri-pencil-line"></i>
                        </Button>
                        <Button
                          size="sm"
                          color="danger"
                          className="btn btn-outline-danger"
                          onClick={() => handleDelete(asset.asset_id)}
                        >
                        <i className="ri-delete-bin-line"></i>
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>

  );
}

export default AssetTable;
